import { Component, Input, OnChanges } from '@angular/core';
import { SafeHtmlPipe } from '../../../../../sb-tools/typescript/pipes/safe-html.pipe';

@Component({
    selector: 'app-read-more',
    templateUrl: './read-more.component.html',
    styleUrls: ['./read-more.component.scss'],
    imports: [SafeHtmlPipe],
})
export class ReadMoreComponent implements OnChanges {
    @Input() text: string;
    @Input() maxLength = 50;

    currentText: string;
    hideToggle = true;
    isCollapsed = true;

    ngOnChanges() {
        this.determineView();
    }

    private determineView() {
        if (!this.text || this.text.length <= this.maxLength) {
            this.currentText = this.text;
            this.isCollapsed = false;
            this.hideToggle = true;
            return;
        }
        this.hideToggle = false;
        if (this.isCollapsed === true) {
            this.currentText = this.text.substring(0, this.maxLength) + '...';
        } else if (this.isCollapsed === false) {
            this.currentText = this.text;
        }
    }

    public toggleView() {
        this.isCollapsed = !this.isCollapsed;
        this.determineView();
    }
}
